<template>
  <form-section
    v-if="item && item.parametrizable_pricings && item.parametrizable_pricings.length > 0"
    class="parametrizable-pricings-section"
    :inititally-visible="!item.published"
    :section-title="$t('components.loanable.form.parametrizable_pricings_section.title')"
    toggleable
  >
    <b-row v-if="requiresPricingParametersFile" class="mb-3">
      <b-col>
        <i18n
          path="components.loanable.form.parametrizable_pricings_section.calculator_message"
          tag="p"
          class="mb-0"
        >
          <template #calculator_link>
            <a
              :href="
                $t('components.loanable.form.parametrizable_pricings_section.calculator_link_url')
              "
              target="_blank"
              >{{
                $t("components.loanable.form.parametrizable_pricings_section.calculator_link")
              }}</a
            >
          </template>
        </i18n>

        <forms-validated-input
          v-model="item.pricing_parameters_file"
          :accept="[
            '*.pdf',
            'application/pdf',
            '*.ods',
            'application/vnd.oasis.opendocument.spreadsheet',
            '*.xls',
            'application/vnd.ms-excel',
            '*.xlsx',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ]"
          :label="$t('components.loanable.form.pricing_parameters_file_upload')"
          name="pricing_parameters_file"
          type="file"
        />
      </b-col>
    </b-row>

    <div v-for="pricing in item.parametrizable_pricings" :key="pricing.id" class="mt-3">
      <b-row>
        <b-col>
          <h3 v-if="pricing.community" class="mb-3">
            {{ pricing.community.name }}: {{ pricing.name }}
          </h3>
          <h3 v-else class="mb-3">{{ pricing.name }}</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <p v-if="requiresPricingParametersFile && !hasPricingParametersFile" class="mb-3">
            {{ $t("components.loanable.form.pricing_section_partially_disabled") }}
          </p>
          <loanable-edit-pricing-parameters
            :pricing="pricing"
            :value="item.parameters"
            :custom-pricing-disabled="requiresPricingParametersFile && !hasPricingParametersFile"
            @update="updateParameters(pricing.community_id ?? 0, $event)"
          />
        </b-col>
      </b-row>
    </div>
  </form-section>
</template>

<script>
import FormSection from "@/components/Loanable/FormSection.vue";
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";
import LoanableEditPricingParameters from "@/components/Loanable/LoanableEditPricingParameters.vue";

export default {
  name: "ParametrizablePricingsSection",
  components: {
    FormSection,
    FormsValidatedInput,
    LoanableEditPricingParameters,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    requiresPricingParametersFile: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasPricingParametersFile() {
      return !!this.item?.pricing_parameters_file;
    },
  },
  methods: {
    updateParameters(pricingId, parameters) {
      console.log(pricingId, parameters);
      this.$emit("update", { pricingId, parameters });
    },
  },
};
</script>
